function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { scrollToTargetAdjusted } from "../../utils/ui";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Pagination = function Pagination(_ref) {
  var scrollTo = _ref.scrollTo,
    currentPage = _ref.currentPage,
    onPageChange = _ref.onPageChange,
    totalPages = _ref.totalPages,
    _ref$maxPages = _ref.maxPages,
    maxPages = _ref$maxPages === void 0 ? 4 : _ref$maxPages,
    config = _ref.config;
  var isPrevActive = currentPage !== 1;
  var isNextActive = currentPage !== totalPages;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    basePage = _useState2[0],
    setBasePage = _useState2[1];
  var onChangeOfPage = function onChangeOfPage(page) {
    // console.log('SCROLLLLL', scrollTo);
    if (scrollTo) {
      scrollToTargetAdjusted(scrollTo, config);
    }
    if (page % maxPages === 1) {
      setBasePage(page);
    } else if (page % maxPages === 0) {
      setBasePage(page - maxPages + 1);
    } else {
      setBasePage(page - page % maxPages + 1);
    }
    onPageChange(page);
  };
  var pageArr = [];
  for (var i = basePage - 1; i < basePage + maxPages - 1; ++i) {
    if (i + 1 <= totalPages) {
      pageArr.push(i + 1);
    } else {
      break;
    }
  }
  if (totalPages <= 1) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "z-20 flex ",
    children: [totalPages > 1 && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("button", {
        disabled: !isPrevActive,
        className: "btn bg-white text-black border-none hover:bg-primary hover:text-white z-20 ".concat(!isPrevActive ? "" : ""),
        onClick: function onClick() {
          return onChangeOfPage(currentPage - 1);
        },
        children: "\xAB"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "",
      children: pageArr.map(function (page) {
        // console.log(
        //     'page ->',
        //     page,
        //     currentPage,
        //     page === currentPage
        // );
        return /*#__PURE__*/_jsx("button", {
          onClick: function onClick() {
            return onChangeOfPage(page);
          },
          className: "btn z-20 ml-2 ".concat(page === currentPage ? "bg-primary text-white" : "bg-white text-black", " border-none hover:bg-primary hover:text-white"),
          children: page < 10 ? "0".concat(page) : page
        }, page);
      })
    }), totalPages > 1 && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("button", {
        onClick: function onClick() {
          return onChangeOfPage(currentPage + 1);
        },
        disabled: !isNextActive,
        className: "btn ml-2 z-20 bg-white text-black border-none hover:bg-primary hover:text-white ".concat(!isNextActive ? "" : ""),
        children: "\xBB"
      })
    })]
  });
};
export default Pagination;